import { render, staticRenderFns } from "./KvmSparkline.vue?vue&type=template&id=5222cfd8&scoped=true&"
import script from "./KvmSparkline.vue?vue&type=script&lang=js&"
export * from "./KvmSparkline.vue?vue&type=script&lang=js&"
import style0 from "./KvmSparkline.vue?vue&type=style&index=0&id=5222cfd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222cfd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5222cfd8')) {
      api.createRecord('5222cfd8', component.options)
    } else {
      api.reload('5222cfd8', component.options)
    }
    module.hot.accept("./KvmSparkline.vue?vue&type=template&id=5222cfd8&scoped=true&", function () {
      api.rerender('5222cfd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmSparkline.vue"
export default component.exports